import { axiosWithToken } from "@/utils/axios";
import { AxiosResponse } from "axios";
import { GetPropertyByUserResponse } from "@/types/property";

class ServiceClass {
  getAllDevelopers(payload?: any) {
    return axiosWithToken().get("/developers", {
      params: payload,
    });
  }

  getDeveloperById(developerId: string) {
    return axiosWithToken().get(`/developers/${developerId}`);
  }

  /**
   * A developer's portfolio is served by the generic user-properties endpoint
   * (`GET /user/:id/properties`); the backend exposes no
   * `GET /developers/:id/properties` route.
   */
  getPropertiesByDeveloper(
    developerId: string,
    params?: {
      pageNumber?: number;
      pageSize?: number;
      cursor?: string;
      beforeCursor?: string;
      location?: string;
      listingType?: string;
      propertyType?: string;
      status?: string;
    },
  ): Promise<AxiosResponse<GetPropertyByUserResponse>> {
    return axiosWithToken().get(`/user/${developerId}/properties`, {
      params,
    });
  }
}

const DeveloperService = new ServiceClass();
export default DeveloperService;
